import { QuestionCircleOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { Popover } from "antd";
import React, { useState } from "react";

const Icon = styled.span`
  cursor: pointer;
  .icon {
    color: #777;
    margin-left: 5px;
  }
`;

function Component({ className, text }) {
  const [visible, setVisible] = useState(false);

  return (
    <Popover
      color="#f2f2f2"
      content={text}
      onVisibleChange={setVisible}
      overlayClassName={className}
      placement="topLeft"
      trigger="click"
      visible={visible}
    >
      <Icon>
        <QuestionCircleOutlined className="icon" />
      </Icon>
    </Popover>
  );
}

const Info = styled(Component)`
  padding: 0;
  .ant-popover-inner {
    box-shadow: none;
    background: #f5f5f5;
  }
  .ant-popover-arrow {
    display: none;
  }
`;

export { Info };
